var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7823 4H5.30728C4.60336 4 4 4.7 4 5.5V18.4C4 19.3 4.60336 20 5.30728 20H18.6817C19.3856 20 19.989 19.3 19.989 18.5V5.5C20.0896 4.7 19.4862 4 18.7823 4ZM14 7H17V8H14V7ZM14 9H17V10H14V9ZM14 11H17V12H14V11ZM17 17H7V16H17V17ZM17 15H7V14H17V15ZM12 12H7V7H12V12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.42f4193c268f62860dc57fcb662339db.svg";
export { ForwardRef as ReactComponent };